import React from 'react';
import styled from 'styled-components';
import { useTextViewStore } from '../../shared/store/TextViewStore';
import { getWorksMessage } from '../../shared/constants/pageMessages';
import RelatedProject from '../work/RelatedProject';
import { useEditMode } from '../../shared/hooks/useEditMode';

const RelatedProjectList: React.FC = () => {
  const { isEditMode } = useEditMode();
  const activeText = useTextViewStore((s) => s.activeText);
  const activeRelatedProjectList = useTextViewStore((s) => s.activeRelatedProjectList);

  if (activeText === null) {
    return null;
  }

  return (
    <>
      {!isEditMode && activeRelatedProjectList.length > 0 &&
        <>
          <RelatedProjectTitle>{getWorksMessage('RELATED_PROJECT')}</RelatedProjectTitle>
          <RelatedProjectContainer>
            {activeRelatedProjectList.map((rp, index) => (
              <RelatedProject key={rp.id} index={index + 1} data={rp} />
            ))}
          </RelatedProjectContainer>
        </>
      }
    </>
  );
}

const RelatedProjectTitle = styled.h3`
  width: 100%;
  display: flex;
  align-items: center;

  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_03_1};
`;

const RelatedProjectContainer = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;


export default RelatedProjectList;